import { useEffect, useState } from 'react';

import { Button, Col, Input, Label, Row } from 'reactstrap';
import { Modal } from '../../../Components/Custom/modal';
import { useAppDispatch } from '../../../app/hooks';
import { addblacklistWallet } from './slice';

export const AddBlacklistWallet = () => {
  const dispatch = useAppDispatch();

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [address, setAddress] = useState<string>('');

  const [remark, setRemark] = useState<string>('');

  const handleSubmit = (e: any) => {
    e.preventDefault();

    const data = {
      address,
      remark
    };

    dispatch(addblacklistWallet(data));
    handleClearState();
  };

  const handleClearState = () => {
    setIsOpen(!isOpen);

    setAddress('');
    setRemark('');
  };

  return (
    <>
      <Button color='primary' onClick={() => setIsOpen(!isOpen)}>
        Add Wallet
      </Button>
      <Modal
        isOpen={isOpen}
        setIsOpen={() => setIsOpen(!isOpen)}
        title='Add Blacklist wallet '
        size='xl'
        form
        onFormSubmit={handleSubmit}
        actions={
          <>
            <Button color='primary' onClick={handleClearState}>
              Cancel
            </Button>
            <Button
              color='primary'
              type='submit'
              disabled={!address || !remark}>
              Add
            </Button>
          </>
        }>
        <Row>
          <Col lg={12}>
            <Col lg={6}>
              <Label className='w-100 text-left' for='address'>
                Wallet address
              </Label>
              <Input
                id='address'
                className='w-100 mb-2'
                type='text'
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                placeholder='Enter here'
              />
            </Col>
          </Col>
          <Col lg={12}>
            <Col lg={6}>
              <Label for='title'>Remark</Label>
              <Input
                id='title'
                className='w-100 mb-2'
                type='textarea'
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder='Enter here'
              />
            </Col>
          </Col>
        </Row>
      </Modal>
    </>
  );
};
